// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_2h-3";
export var dialog = "_2h-0";
export var divClassnameSwatch = "_2h-8";
export var flexSwatch = "_2h-4";
export var header = "_2h-1";
export var styleAttributeSwatch = "_2h-7";
export var swatch = "_2h-2";
export var textHeaderSwatch = "_2h-5";
export var webSwatch = "_2h-6";